(() => {
  const key = Symbol.for('collectionMouseDrag');
  if (window[key]) return;
  window[key] = true;

  const selector = '.collection slider-component ul.slider[id^="Slider-"]';
  const controls = 'button, input, select, textarea, label, summary, [contenteditable]:not([contenteditable="false"]), [role="button"]';
  let gesture = null;
  let blockedSlider = null;
  let unblockTimer;

  function getSlider(target) {
    if (!(target instanceof Element)) return null;
    const slider = target.closest(selector);
    if (!slider || slider.scrollWidth <= slider.clientWidth + 1) return null;
    if (!['auto', 'scroll'].includes(getComputedStyle(slider).overflowX)) return null;
    return slider;
  }

  function finish() {
    if (!gesture) return;
    const { slider, pointerId, dragging } = gesture;
    gesture = null;
    if (dragging) {
      slider.classList.remove('collection-mouse-dragging');
      if (slider.hasPointerCapture(pointerId)) slider.releasePointerCapture(pointerId);
      // A pointer-generated click follows pointerup. Preserve keyboard clicks.
      blockedSlider = slider;
      clearTimeout(unblockTimer);
      unblockTimer = setTimeout(() => { blockedSlider = null; }, 400);
    }
  }

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary) return;
    if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
    const slider = getSlider(event.target);
    if (!slider || event.target.closest(controls)) return;
    finish();
    blockedSlider = null;
    clearTimeout(unblockTimer);
    gesture = {
      slider,
      pointerId: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      startScroll: slider.scrollLeft,
      dragging: false,
    };
  });

  document.addEventListener('pointermove', (event) => {
    if (!gesture || event.pointerId !== gesture.pointerId) return;
    if (!(event.buttons & 1)) { finish(); return; }
    const dx = event.clientX - gesture.startX;
    const dy = event.clientY - gesture.startY;
    if (!gesture.dragging) {
      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
      if (Math.abs(dy) > Math.abs(dx)) { finish(); return; }
      gesture.dragging = true;
      gesture.slider.classList.add('collection-mouse-dragging');
      gesture.slider.setPointerCapture(event.pointerId);
      window.getSelection()?.removeAllRanges();
    }
    event.preventDefault();
    gesture.slider.scrollLeft = gesture.startScroll - dx;
  }, { passive: false });

  for (const type of ['pointerup', 'pointercancel', 'lostpointercapture']) {
    document.addEventListener(type, (event) => {
      if (gesture && event.pointerId === gesture.pointerId) finish();
    });
  }
  window.addEventListener('blur', finish);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) finish();
  });

  document.addEventListener('click', (event) => {
    if (!blockedSlider || event.detail === 0 || !(event.target instanceof Node)) return;
    if (blockedSlider.contains(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      blockedSlider = null;
      clearTimeout(unblockTimer);
    }
  }, true);

  // Prevent the browser's native image/link drag from taking over the gesture.
  document.addEventListener('dragstart', (event) => {
    if (gesture && getSlider(event.target) === gesture.slider) event.preventDefault();
  });
})();
